import Main from "./Main";
import radioData from "./RadioData";
import SiteData from "./SiteData";
import Support from "./Support";
import Auth from "./Auth";
import Administration from "./Administration";

// ** Document title
const TemplateTitle = "%s - Quantum Web Radio ";

// ** Default Route
const DefaultRoute = "/admin/dashboard";

// ** Merge Routes
const Routes = [
  ...radioData,
  ...Main,
  ...SiteData,
  ...Support,
  ...Auth,
  ...Administration,
];

export { DefaultRoute, TemplateTitle, Routes };
